/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SegmentRuleProperties } from '../../defs/SegmentRuleProperties.defs';
import { UISegmentRuleProperties } from '../../defs/UISegmentRuleProperties.defs';

/**
 * Prepare the rules for the API.
 * @param {Array<UISegmentRuleProperties>} rules The rules configured in the form.
 * @returns {Array<SegmentRuleProperties>} List of rules structured for the API.
 */
export const createRulesForAPI = (rules: Array<UISegmentRuleProperties>): Array<SegmentRuleProperties> => {
  const arrayOfRules: Array<SegmentRuleProperties> = [];

  rules.forEach((rule) => {
    const { id: _, ...ruleWithoutId } = rule;
    arrayOfRules.push(ruleWithoutId);
  });

  return arrayOfRules;
};
